<template>
  <div class="downlo">
    <div>Fazendo Download...</div>
    <div class="d-flex">
      <div class="mr-1">
        Caso o download não tenha iniciado sozinho, por favor
      </div>
      <div class="clique" @click="download">Clique aqui</div>
    </div>
  </div>
</template>
<script>
import { seloClienteOcultoEvidenciasAPI } from "../API/seloClienteOcultoEvidenciasAPI";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      evidence: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    download(nomeArquivo) {
      seloClienteOcultoEvidenciasAPI
        .download(this.$route.params.evidenceId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.download = nomeArquivo;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
  },
  async mounted() {
    this.setLoading(true);
    try {
      const val = await seloClienteOcultoEvidenciasAPI.get(
        this.$route.params.evidenceId
      );
      this.download(val.data.nomeArquivo);
    } catch (error) {}
  },
};
</script>
<style scoped>
.downlo {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.clique {
  color: var(--corPrimaria);
  font-weight: bold;
  cursor: pointer;
}
</style>
